import * as types from '../mutation-types'
import Vue from 'vue'

const state = {
  selectedClass: null,
  activeTab: 'classes'
}

const getters = {
  selectedClass: state => state.selectedClass,
  activeTab: state => state.activeTab
}

const actions = {
  selectClass ({ commit }, selectedClass) {
    commit(types.SELECT_CLASS, { selectedClass })
  },
  clearClassSelection ({ commit }) {
    commit(types.CLEAR_CLASS)
  },
  setActiveTab ({ commit }, activeTab) {
    commit(types.SET_ACTIVE_TAB, { activeTab })
  }
}

const mutations = {
  [types.SELECT_CLASS] (state, { selectedClass }) {
    Vue.set(state, 'selectedClass', selectedClass)
  },
  [types.CLEAR_CLASS] (state) {
    Vue.set(state, 'selectedClass', null)
  },
  [types.SET_ACTIVE_TAB] (state, { activeTab }) {
    Vue.set(state, 'activeTab', activeTab)
  },
  [types.RESET_ON_LOGOUT] (state) {
    state.selectedClass = null
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
